module.exports = __webpack_public_path__ + "static/source-7fb19852981397415b28e37ef2587a4a.jpg";